<template>
  <div id="app">
   
    <NavBar />
    <router-view></router-view>
    
    
    <BottomFooter />
    
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import BottomFooter from './components/BottomFooter.vue';

export default {
  name: "App",
  components: { NavBar, BottomFooter }
};
</script> 

<style>
html {
  scroll-behavior: smooth;
}
body {
  margin: 0;
  font-family: Arial, sans-serif;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.navbar {
  display: flex;
  justify-content: space-between;
  background: #206A98;
  padding: 20px 30px;
  color: white;
}
.navbar .logo {
  display: flex;
  align-items: center;
}
.navbar ul {
  list-style: none;
  display: flex;
  gap: 30px;
}
.navbar a {
  color: white;
  text-decoration: none;
}
.navbar a:hover {
  text-decoration: underline;
}
main {
  padding: 20px;
}
footer {
  text-align: center;
  background: #206A98;
  color: white;
  padding: 10px;
  margin-top: 20px;
}
section {
  padding: 0px 10px;
}
</style>



